<template>
  <nk-page commercialAccess="Salary" policyClaims="Salary_SalaryItem_Management">
    <div class="h-100 nk-card">
      <ag-grid :options="componentOptions.tableOptions" :data="tableData"></ag-grid>
    </div>
  </nk-page>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'
  import { post } from '@/plugins/nikan-api'
  import Endpoints from '@nikan/endpoints'
  import Merge from 'lodash/merge'
  import { IResponseList } from '@/interfaces/base'
  import { GridOptions } from 'ag-grid-community'
  import BooleanView from '@/components/form/boolean-label.vue'

  interface IDependency {
    code: string
    isActive: boolean
    displayName: string
  }

  export default defineComponent({
    name: 'salary-item-dependency',
    modal: {
      size: 'lg',
      stateUID: 'salary-item-dependency'
    },
    props: {
      options: Object
    },
    data() {
      return {
        tableData: [] as IDependency[],
        settings: {
          salaryItemId: '',
        },
        componentOptions: {
          tableOptions: {
            id: this.$options.name,
            pagination: false,
            cellSelectionAggReport: false,
            groupIncludeTotalFooter: true,
            enterToSelect: true,
            suppressRowHoverHighlight: false,
            rowSelection: {
              mode: 'singleRow',
              enableClickSelection: false
            },
            sideBar: 'none',
            columnDefs: [
              {
                field: 'rowNumber',
                headerName: this.$t('row-number'),
                width: 80,
                maxWidth: 120,
                aggFunc: 'count',
              },
              {
                field: 'code',
                headerName: this.$t('salary.item.item-code'),
                contentType: 'string',
                filter: true
              },
              {
                field: 'displayName',
                headerName: this.$t('salary.item.display-name'),
                contentType: 'string',
                filter: true
              },
              {
                field: 'isActive',
                headerName: this.$t('salary.active'),
                filter: true,
                contentType: 'enum',
                cellClass: ' text-center',
                valueFormatter: (data: any) => typeof data.value === 'boolean' && this.$t(`boolean-yes-no.${data.value}`),
                cellRenderer: BooleanView,
                cellRendererParams: (data: any) => {
                  return {
                    options: {
                      useColors: true,
                      modelValue: data.value
                    },
                  }
                },
                width: 75
              }
            ]
          } as GridOptions
        }
      }
    },
    created() {
      this.settings = Merge(this.settings, this.options)
    },
    mounted() {
      this.prepareWindow(this.$t('salary.salary-item.dependency'))
      this.getData()
    },
    methods: {
      getData() {
        const wait = this.$wait(this.$el)
        post(Endpoints.getUrl('salaryItem.getDependency'), { salaryItemId: this.settings.salaryItemId }).then((res: IResponseList<IDependency>) => {
          this.tableData = res.data.items
        }).catch(() => {

        }).finally(() => {
          wait.end()
        })
      }
    }
  })

</script>
<style></style>